import { Grid, Typography } from '@mui/material';

export function MissingDetails() {
  return (
    <>
      <Grid item xs={12}>
        <Typography
          component="h5"
          sx={{
            fontSize: '1.5em',
            color: 'red',
          }}
        >
          Not provided!
        </Typography>
      </Grid>
    </>
  );
}
